import { createRouter, createWebHistory } from 'vue-router'
import routerList from './router'
import config from '@/config'
const routes = routerList

const router = createRouter({
  history: createWebHistory(config.BASE_URL),
  routes
})
router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
})
export default router
